import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState } from 'react';
import ModalWindow from '../Window';
import Webcam from "react-webcam";
import Grid from '@material-ui/core/Grid';

var WebCam = function WebCam(props) {
  var onClose = props.onClose,
      onConfirm = props.onConfirm,
      title = props.title,
      confirmLabel = props.confirmLabel,
      confirmColor = props.confirmColor;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorResponse = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showWebCam = _useState4[0],
      setShowWebCam = _useState4[1];

  var webcamRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      imgSrc = _React$useState2[0],
      setImgSrc = _React$useState2[1];

  var capture = React.useCallback(function () {
    var imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    setShowWebCam(false);
  }, [webcamRef, setImgSrc]);

  var confirmFn = function confirmFn() {
    if (errorResponse) setError(null);
    if (!onConfirm) return;
    var promise = onConfirm(imgSrc);

    if (promise) {
      return promise.catch(function (action) {
        setError(action.payload);
        throw action;
      });
    }
  };

  var getFooterButtons = function getFooterButtons() {
    var buttons = {};
    buttons['submit'] = {
      children: confirmLabel,
      color: confirmColor,
      disabled: showWebCam,
      onClick: confirmFn
    };
    buttons['leftAction'] = {
      children: showWebCam ? 'Capture Photo' : 'Take another photo',
      color: confirmColor,
      disabled: false,
      variant: 'contained',
      onClick: showWebCam ? capture : function () {
        return setShowWebCam(true);
      }
    };
    buttons['cancel'] = {};
    return buttons;
  };

  return React.createElement(ModalWindow, {
    onClose: onClose,
    style: {
      width: 800
    },
    borderLess: true,
    overlay: true,
    header: title,
    error: errorResponse && errorResponse.error,
    content: React.createElement(Grid, {
      container: true,
      direction: "row"
    }, showWebCam && React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      justify: "center"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Webcam, {
      audio: false,
      ref: webcamRef,
      screenshotFormat: "image/jpeg"
    }))), imgSrc && !showWebCam && React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      justify: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement("img", {
      src: imgSrc
    })))),
    footerButtons: getFooterButtons()
  });
};

WebCam.defaultProps = {
  title: 'Take a photo',
  confirmLabel: 'Apply',
  confirmColor: 'primary',
  hideCancel: false
};
export default WebCam;